import { ICallTrackingActivity } from '@user/features/CampaignTracking/typings'
import { ILeadFormModel } from './typings'
import { useFormikContext } from 'formik'
import {
  CampaignFieldId,
  campaignNone,
  leadSourceNone,
  leadSourceNoneId,
  SourceFieldId,
} from '@user/components/Settings/EntityFormSettings'
import { ISource } from '@user/store/sources'
import { ICampaign } from '@user/store/campaigns'

export function PrefillCallTrackingData(
  setValues: ReturnType<typeof useFormikContext<ILeadFormModel>>['setValues'],
  callTrackingActivity: ICallTrackingActivity,
  leadSources: ISource[],
  campaigns: ICampaign[],
) {
  if (callTrackingActivity?.callerDetails) {
    const callSourceName = callTrackingActivity?.callActivityDetails
      .find((x) => x.callTrackingSystemFieldId === SourceFieldId)
      ?.fieldValue?.toUpperCase()
    const callCampaignName = callTrackingActivity?.callActivityDetails
      .find((x) => x.callTrackingSystemFieldId === CampaignFieldId)
      ?.fieldValue?.toUpperCase()
    setValues((v) => {
      const emailAddresses = [...v.emailAddresses]
      emailAddresses[0] = {
        emailAddress:
          emailAddresses[0]?.emailAddress?.trim().length == 0 &&
          callTrackingActivity?.callerDetails?.email
            ? callTrackingActivity?.callerDetails.email
            : emailAddresses[0]?.emailAddress || '',
        isPrimary: true,
      }
      const source = callSourceName
        ? leadSources.find((x) => x.name.substring(0, 10) === callSourceName)
        : null
      const campaign = callCampaignName
        ? campaigns.find((x) => x.name.substring(0, 10) === callCampaignName)
        : null
      return {
        ...v,
        emailAddresses: emailAddresses,
        firstName:
          v.firstName?.trim().length == 0 &&
          callTrackingActivity?.callerDetails?.firstName
            ? callTrackingActivity?.callerDetails?.firstName
            : v.firstName,
        lastName:
          v.lastName?.trim().length == 0 &&
          callTrackingActivity?.callerDetails?.lastName
            ? callTrackingActivity?.callerDetails?.lastName
            : v.lastName,
        address1:
          v.address1?.trim().length == 0 &&
          callTrackingActivity?.callerDetails?.street
            ? callTrackingActivity?.callerDetails?.street
            : v.address1,
        city:
          v.city.trim().length == 0 && callTrackingActivity?.callerDetails?.city
            ? callTrackingActivity?.callerDetails?.city
            : v.city,
        state:
          v.state.trim().length == 0 &&
          callTrackingActivity?.callerDetails?.state
            ? callTrackingActivity?.callerDetails?.state
            : v.state,
        postalCode:
          v.postalCode.trim().length == 0 &&
          callTrackingActivity?.callerDetails?.postalCode
            ? callTrackingActivity?.callerDetails?.postalCode
            : v.postalCode,
        CallTrackingSystemFieldValues:
          callTrackingActivity?.callActivityDetails,
        leadSourceId: source ? source.id : v.leadSourceId || leadSourceNoneId,
        leadSource:
          source && source.name.trim().length > 0
            ? source.name
            : leadSourceNone,
        campaignId: campaign ? campaign.id : '-1',
        campaign:
          campaign && campaign.name.trim().length > 0
            ? campaign.name
            : campaignNone,
        type:
          callTrackingActivity?.direction == 'inbound' ||
          callTrackingActivity?.direction == 'form'
            ? callTrackingActivity?.direction == 'inbound'
              ? 'Phone'
              : callTrackingActivity?.direction == 'form'
              ? 'Web'
              : 'Manual'
            : 'Manual',
      }
    })
  }
}
